import { render, staticRenderFns } from "./ViasForBooking.vue?vue&type=template&id=488f78f4&scoped=true&"
import script from "./ViasForBooking.vue?vue&type=script&lang=js&"
export * from "./ViasForBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f78f4",
  null
  
)

export default component.exports